import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { TextFieldStyle } from '../text-field';

@Component({
  selector: 'pcs-filled-text-field',
  template: '{{text | translate}}',
  styleUrls: ['./filled-text-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilledTextFieldComponent {
  @Input() text: string;
  @Input() filledTextStyle: TextFieldStyle;
  @HostBinding('class.size-lg')
  @Input() large = false;

  @HostBinding('class.success')
  private get success() {
    return this.filledTextStyle === TextFieldStyle.Success;
  }

  @HostBinding('class.info')
  private get info() {
    return this.filledTextStyle === TextFieldStyle.Info;
  }

  @HostBinding('class.error')
  private get error() {
    return this.filledTextStyle === TextFieldStyle.Error;
  }

  @HostBinding('class.warning')
  private get warning() {
    return this.filledTextStyle === TextFieldStyle.Warning;
  }

}
